import { useState } from "react";
import { InlineEditableListItem, AddItemButton } from "./InlineEditable";

const ImportantNotesSection = ({ importantNotes = [], onUpdate, isEditMode = false }) => {
  const [notes, setNotes] = useState(importantNotes);

  if (JSON.stringify(notes) !== JSON.stringify(importantNotes) && !isEditMode) {
    setNotes(importantNotes);
  }

  const handleNoteChange = (index, newValue) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = newValue;
    setNotes(updatedNotes);
    onUpdate && onUpdate(updatedNotes);
  };

  const handleDeleteNote = (index) => {
    const updatedNotes = notes.filter((_, i) => i !== index);
    setNotes(updatedNotes);
    onUpdate && onUpdate(updatedNotes);
  };

  const handleAddNote = () => {
    const updatedNotes = [...notes, "New important note - click to edit"];
    setNotes(updatedNotes);
    onUpdate && onUpdate(updatedNotes);
  };

  if ((!notes || notes.length === 0) && !isEditMode) return null;

  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-6 lg:p-8 mb-6 border border-amber-200">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-amber-900 flex items-center gap-3">
          <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Important Information
        </h2>
        {isEditMode && (
          <span className="text-xs text-amber-600 bg-amber-100 px-2 py-1 rounded-full">
            Click any item to edit
          </span>
        )}
      </div>

      <ul className="space-y-3">
        {notes.map((note, index) => (
          <InlineEditableListItem
            key={index}
            value={note}
            onSave={(newValue) => handleNoteChange(index, newValue)}
            onDelete={() => handleDeleteNote(index)}
            isEditMode={isEditMode}
            placeholder="Enter an important note..."
            icon="•"
            className="text-amber-800"
          />
        ))}
      </ul>

      {isEditMode && (
        <div className="mt-4 pt-4 border-t border-amber-200">
          <AddItemButton
            onClick={handleAddNote}
            label="Add Note"
            className="text-amber-700 hover:bg-amber-100"
          />
        </div>
      )}
    </div>
  );
};

export default ImportantNotesSection;
